export function AdminUserFilter() {
    var filter =  function (userList, showAdminsOnly) {
        var filteredUsers = [];
        angular.forEach(userList, (user) => {
            if (showAdminsOnly) {
                if (showAdminsOnly === user.isOrganisationAdministrator) {
                    filteredUsers.push(user);
                }
            }
            else {
                filteredUsers.push(user);
            }
        });
        return filteredUsers;
    };
    return filter;
}
